import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
// Dev
import accountDev from './dev/account.json'
import alertDev from './dev/alert.json'
import commonDev from './dev/common.json'
import commonDistanceDev from './dev/commonDistance.json'
import crTargetDev from './dev/crTarget.json'
// import detailsMgmtDev from './dev/detailsMgmt.json'
import deviceDev from './dev/device.json'
import formItemsDev from './dev/formItems.json'
import globalEmSourceDev from './dev/globalEmSource.json'
import goodsDev from './dev/goods.json'
import importSettingDev from './dev/importSetting.json'
import menuDev from './dev/menu.json'
// import modifyDetailsModalDev from './dev/modifyDetailsModal.json'
import powerinputDev from './dev/powerinput.json'
import regionCoeffiDev from './dev/regionCoeffi.json'
// import reportApprovalDev from './dev/report-approval.json'
import globalCarbonReductionDev from './dev/report-globalCarbonReduction.json'
import globalEmDev from './dev/report-globalEm.json'
import reportDev from './dev/report.json'
import systemDev from './dev/system.json'
import tableColumnsDev from './dev/tableColumns.json'
// EN
import accountEN from './en_US/account.json'
import alertEN from './en_US/alert.json'
import autoSearchEN from './en_US/autoSearch.json'
import commonEN from './en_US/common.json'
import commonDistanceEN from './en_US/commonDistance.json'
import crTargetEN from './en_US/crTarget.json'
import custCarbonAuditEN from './en_US/custCarbonAudit.json'
import detailsMgmtEN from './en_US/detailsMgmt.json'
import deviceEN from './en_US/device.json'
import documentShareEN from './en_US/documentShare.json'
import esgAnnualInfoEN from './en_US/esgAnnualInfo.json'
import formItemsEN from './en_US/formItems.json'
import globalEmSourceEN from './en_US/globalEmSource.json'
import goodsEN from './en_US/goods.json'
import importSettingEN from './en_US/importSetting.json'
import languagesEN from './en_US/languages.json'
import menuEN from './en_US/menu.json'
import modifyDetailsModalEN from './en_US/modifyDetailsModal.json'
import powerSavingEN from './en_US/powerSaving.json'
import powerinputEN from './en_US/powerinput.json'
import regionCoeffiEN from './en_US/regionCoeffi.json'
import rentalAssetsEN from './en_US/rentalAssets.json'
import reportApprovalEN from './en_US/report-approval.json'
import globalCarbonReductionEN from './en_US/report-globalCarbonReduction.json'
import globalEmEN from './en_US/report-globalEm.json'
import reportEN from './en_US/report.json'
import ssoLoginEN from './en_US/ssoLogin.json'
import systemEN from './en_US/system.json'
import tableColumnsEN from './en_US/tableColumns.json'
// ZhTW
import accountZhTW from './zh_TW/account.json'
import alertZhTW from './zh_TW/alert.json'
import autoSearchZhTW from './zh_TW/autoSearch.json'
import commonZhTW from './zh_TW/common.json'
import commonDistanceZhTW from './zh_TW/commonDistance.json'
import crTargetZhTW from './zh_TW/crTarget.json'
import custCarbonAuditZhTW from './zh_TW/custCarbonAudit.json'
import detailsMgmtZhTW from './zh_TW/detailsMgmt.json'
import deviceZhTW from './zh_TW/device.json'
import documentShareZhTW from './zh_TW/documentShare.json'
import esgAnnualInfoZhTW from './zh_TW/esgAnnualInfo.json'
import formItemsZhTW from './zh_TW/formItems.json'
import globalEmSourceZhTW from './zh_TW/globalEmSource.json'
import goodsZhTW from './zh_TW/goods.json'
import importSettingZhTW from './zh_TW/importSetting.json'
import languagesZhTW from './zh_TW/languages.json'
import menuZhTW from './zh_TW/menu.json'
import modifyDetailsModalZhTW from './zh_TW/modifyDetailsModal.json'
import powerSavingZhTW from './zh_TW/powerSaving.json'
import powerinputZhTW from './zh_TW/powerinput.json'
import regionCoeffiZhTW from './zh_TW/regionCoeffi.json'
import rentalAssetsZhTW from './zh_TW/rentalAssets.json'
import reportApprovalZhTW from './zh_TW/report-approval.json'
import globalCarbonReductionZhTW from './zh_TW/report-globalCarbonReduction.json'
import globalEmZhTW from './zh_TW/report-globalEm.json'
import reportZhTW from './zh_TW/report.json'
import ssoLoginZhTW from './zh_TW/ssoLogin.json'
import systemZhTW from './zh_TW/system.json'
import tableColumnsZhTW from './zh_TW/tableColumns.json'

// the translations
let resources: any = {
  en_US: {
    menu: menuEN,
    alert: alertEN,
    account: accountEN,
    common: commonEN,
    device: deviceEN,
    formItems: formItemsEN,
    goods: goodsEN,
    report: reportEN,
    system: systemEN,
    tableColumns: tableColumnsEN,
    importSetting: importSettingEN,
    regionCoeffi: regionCoeffiEN,
    commonDistance: commonDistanceEN,
    powerinput: powerinputEN,
    globalEm: globalEmEN,
    crTarget: crTargetEN,
    globalCarbonReduction: globalCarbonReductionEN,
    globalEmSource: globalEmSourceEN,
    detailsMgmt: detailsMgmtEN,
    modifyDetailsModal: modifyDetailsModalEN,
    reportApproval: reportApprovalEN,
    languages: languagesEN,
    custCarbonAudit: custCarbonAuditEN,
    powerSaving: powerSavingEN,
    esgAnnualInfo: esgAnnualInfoEN,
    documentShare: documentShareEN,
    autoSearch: autoSearchEN,
    ssoLogin: ssoLoginEN,
    rentalAssets: rentalAssetsEN,
  },
  zh_TW: {
    alert: alertZhTW,
    account: accountZhTW,
    common: commonZhTW,
    device: deviceZhTW,
    formItems: formItemsZhTW,
    goods: goodsZhTW,
    menu: menuZhTW,
    report: reportZhTW,
    system: systemZhTW,
    tableColumns: tableColumnsZhTW,
    importSetting: importSettingZhTW,
    regionCoeffi: regionCoeffiZhTW,
    commonDistance: commonDistanceZhTW,
    powerinput: powerinputZhTW,
    globalEm: globalEmZhTW,
    crTarget: crTargetZhTW,
    globalCarbonReduction: globalCarbonReductionZhTW,
    globalEmSource: globalEmSourceZhTW,
    detailsMgmt: detailsMgmtZhTW,
    modifyDetailsModal: modifyDetailsModalZhTW,
    reportApproval: reportApprovalZhTW,
    languages: languagesZhTW,
    custCarbonAudit: custCarbonAuditZhTW,
    powerSaving: powerSavingZhTW,
    esgAnnualInfo: esgAnnualInfoZhTW,
    documentShare: documentShareZhTW,
    autoSearch: autoSearchZhTW,
    ssoLogin: ssoLoginZhTW,
    rentalAssets: rentalAssetsZhTW,
  },
  dev: {
    alert: alertDev,
    account: accountDev,
    common: commonDev,
    device: deviceDev,
    formItems: formItemsDev,
    goods: goodsDev,
    menu: menuDev,
    report: reportDev,
    system: systemDev,
    tableColumns: tableColumnsDev,
    importSetting: importSettingDev,
    regionCoeffi: regionCoeffiDev,
    commonDistance: commonDistanceDev,
    powerinput: powerinputDev,
    globalEm: globalEmDev,
    crTarget: crTargetDev,
    globalCarbonReduction: globalCarbonReductionDev,
    globalEmSource: globalEmSourceDev,
    // detailsMgmt: detailsMgmtDev,
    // modifyDetailsModal: modifyDetailsModalDev,
    // reportApproval: reportApprovalDev,
  },
}
// 不動, 預設 useTranslateionConfig
const lang = navigator.language.replace('-', '_') || 'en_US'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: [
      'alert',
      'account',
      'common',
      'device',
      'formItems',
      'goods',
      'menu',
      'report',
      'system',
      'tableColumns',
      'importSetting',
      'regionCoeffi',
      'commonDistance',
      'globalEm',
      'crTarget',
      'globalCarbonReduction',
      'globalEmSource',
      'detailsMgmt',
      'modifyDetailsModal',
      'reportApproval',
      'languages',
      'powerinput',
      'powerSaving',
      'esgAnnualInfo',
      'documentShare',
      'autoSearch',
      'ssoLogin',
      'rentalAssets',
    ],
    defaultNS: 'common',
    // fallbackNS: ['common'],
    resources,
    lng: lang,
    fallbackLng: 'en_US',
    keySeparator: false, // we do not use keys in form messages.welcome
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'sub'],
    },
  })

i18n.on('languageChanged', async (lang: string) => {
  // console.log('[resourceStore]', i18n.services.resourceStore.data)
  const currentLang = i18n.services.resourceStore.data[lang]
  if (currentLang) {
    // console.log('[skip import languages]', currentLang, lang)
    return
  }

  // console.log('[import languages]', lang)
  try {
    const _lang = lang

    const jsonFiles = [
      `./${_lang}/account.json`,
      `./${_lang}/alert.json`,
      `./${_lang}/common.json`,
      `./${_lang}/commonDistance.json`,
      `./${_lang}/crTarget.json`,
      `./${_lang}/detailsMgmt.json`,
      `./${_lang}/device.json`,
      `./${_lang}/formItems.json`,
      `./${_lang}/globalEmSource.json`,
      `./${_lang}/goods.json`,
      `./${_lang}/importSetting.json`,
      `./${_lang}/languages.json`,
      `./${_lang}/menu.json`,
      `./${_lang}/modifyDetailsModal.json`,
      `./${_lang}/powerinput.json`,
      `./${_lang}/regionCoeffi.json`,
      `./${_lang}/report-approval.json`,
      `./${_lang}/report-globalCarbonReduction.json`,
      `./${_lang}/report-globalEm.json`,
      `./${_lang}/report.json`,
      `./${_lang}/system.json`,
      `./${_lang}/tableColumns.json`,
      `./${_lang}/custCarbonAudit.json`,
      `./${_lang}/powerSaving.json`,
      `./${_lang}/esgAnnualInfo.json`,
      `./${_lang}/documentShare.json`,
      `./${_lang}/autoSearch.json`,
      `./${_lang}/ssoLogin.json`,
      `./${_lang}/rentalAssets.json`,
    ]

    const [
      account,
      alert,
      common,
      commonDistance,
      crTarget,
      detailsMgmt,
      device,
      formItems,
      globalEmSource,
      goods,
      importSetting,
      languages,
      menu,
      modifyDetailsModal,
      powerinput,
      regionCoeffi,
      reportApproval,
      globalCarbonReduction,
      globalEm,
      report,
      system,
      tableColumns,
      custCarbonAudit,
      powerSaving,
      esgAnnualInfo,
      documentShare,
      autoSearch,
      ssoLogin,
      rentalAssets,
    ]: any[] = await Promise.allSettled(
      jsonFiles.map(file => import(`${file}`, { assert: { type: 'json' } }))
    )

    i18n.addResourceBundle(
      _lang,
      'account',
      account.status === 'fulfilled' && account.value.default
    )
    i18n.addResourceBundle(_lang, 'alert', alert.status === 'fulfilled' && alert.value.default)
    i18n.addResourceBundle(_lang, 'common', common.status === 'fulfilled' && common.value.default)
    i18n.addResourceBundle(
      _lang,
      'commonDistance',
      commonDistance.status === 'fulfilled' && commonDistance.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'crTarget',
      crTarget.status === 'fulfilled' && crTarget.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'detailsMgmt',
      detailsMgmt.status === 'fulfilled' && detailsMgmt.value.default
    )
    i18n.addResourceBundle(_lang, 'device', device.status === 'fulfilled' && device.value.default)
    i18n.addResourceBundle(
      _lang,
      'formItems',
      formItems.status === 'fulfilled' && formItems.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'globalEmSource',
      globalEmSource.status === 'fulfilled' && globalEmSource.value.default
    )

    i18n.addResourceBundle(_lang, 'goods', goods.status === 'fulfilled' && goods.value.default)
    i18n.addResourceBundle(
      _lang,
      'importSetting',
      importSetting.status === 'fulfilled' && importSetting.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'languages',
      languages.status === 'fulfilled' && languages.value.default
    )
    i18n.addResourceBundle(_lang, 'menu', menu.status === 'fulfilled' && menu.value.default)
    i18n.addResourceBundle(
      _lang,
      'modifyDetailsModal',
      modifyDetailsModal.status === 'fulfilled' && modifyDetailsModal.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'powerinput',
      powerinput.status === 'fulfilled' && powerinput.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'regionCoeffi',
      regionCoeffi.status === 'fulfilled' && regionCoeffi.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'reportApproval',
      reportApproval.status === 'fulfilled' && reportApproval.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'globalCarbonReduction',
      globalCarbonReduction.status === 'fulfilled' && globalCarbonReduction.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'globalEm',
      globalEm.status === 'fulfilled' && globalEm.value.default
    )

    i18n.addResourceBundle(_lang, 'report', report.status === 'fulfilled' && report.value.default)
    i18n.addResourceBundle(_lang, 'system', system.status === 'fulfilled' && system.value.default)
    i18n.addResourceBundle(
      _lang,
      'tableColumns',
      tableColumns.status === 'fulfilled' && tableColumns.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'custCarbonAudit',
      custCarbonAudit.status === 'fulfilled' && custCarbonAudit.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'powerSaving',
      powerSaving.status === 'fulfilled' && powerSaving.value.default
    )
    i18n.addResourceBundle(
      _lang,
      'esgAnnualInfo',
      esgAnnualInfo.status === 'fulfilled' && esgAnnualInfo.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'documentShare',
      documentShare.status === 'fulfilled' && documentShare.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'autoSearch',
      autoSearch.status === 'fulfilled' && autoSearch.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'ssoLogin',
      ssoLogin.status === 'fulfilled' && ssoLogin.value.default
    )

    i18n.addResourceBundle(
      _lang,
      'rentalAssets',
      rentalAssets.status === 'fulfilled' && rentalAssets.value.default
    )
  } catch (err) {
    console.log(`載入失敗:`, err)
  }
})

export default i18n
